<div>
    <div class="">
        <div class="card card--box card--new--box">
            <div class="card-block card--box__block pb-0">
                <app-breadcrumb
                        [firstNode]="{label: 'home', 'url': '/patients'}">
                </app-breadcrumb>
            </div>

            <div class="card--new--box__header">
                <div class="card--new--box__header--info">
                    <div class="card--new--box__header__title">
                        {{ 'Support Center' | translate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="card-block card--box__block">
            <div class="hidden" [innerHTML]="content[locale]?.content | safeHtml"></div>

            <h3 class="card--box__block--title mr-t--md">{{'Videos about the Klenico system' | translate}}</h3>
            <div class="row" *ngIf="videos && videos.length; else emptyVideo">
                <ng-container *ngFor="let video of videos; let i=index;">
                    <div class="col-xs-4 item-block item-block--video" *ngIf="(!showAll && i < 9) || showAll">
                        <div class="item-block__details" [routerLink]="[ url]" [queryParams]="{type: 'video', lang: language, id: video.id}">
                            <div class="item-block--title">
                                {{ video['title'] }}
                            </div>
                            <div class="item-block--video--duration">
                                <span class="duration-m" *ngIf="video['duration'].split('.')[0] && video['duration'].split('.')[0] > 0">
                                    {{ video['duration'].split('.')[0] }}{{ 'm' | translate}}
                                </span>
                                <span class="duration-m" *ngIf="video['duration'].split('.')[1] && video['duration'].split('.')[1] > 0">
                                    {{(video['duration'].split('.')[1] * 0.6).toFixed(0)}}{{ 's' | translate}}
                                </span>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <div class="col-xs-4 mr-b--md" *ngIf="!showAll && videos && videos.length > 9">
                    <button type="submit" class="btn btn-primary btn-radius" (click)="showAll = true">
                        <span>{{ 'Show all' | translate }}</span>
                    </button>
                </div>
            </div>
            <div class="row" *ngIf="showAll && videos && videos.length > 9">
                <div class="col-xs-4 mr-b--md">
                    <button type="submit" class="btn btn-primary btn-radius" (click)="showAll = false">
                        <span>{{ 'Show less' | translate }}</span>
                    </button>
                </div>
            </div>
            <ng-template #emptyVideo>
                {{ 'Have no Video' | translate}}
            </ng-template>

            <h3 class="card--box__block--title mr-t--md">{{ 'Our brochures and flyers as PDF' | translate}}</h3>
            <div class="row" *ngIf="pdfs && pdfs.length; else emptyPDF">
                <div class="col-xs-2 item-block item-block--pdf" *ngFor="let pdf of pdfs">
                    <div class="item-block__details" (click)="openPDF(pdf)">
                        <div class="item-block--pdf__title">
                            {{ pdf['title']}}
                        </div>
                        <div class="item-block--thumbnails">
                            <img *ngIf="pdf['picture_url']" [src]="pdf['picture_url']"/>
                        </div>
                    </div>
                </div>
            </div>
            <ng-template #emptyPDF>
                {{ 'Have no PDF' | translate}}
            </ng-template>

        </div>
        <div class="container-fluid" *ngIf="releaseNotes?.length">
            <h3 class="card--box__block--title mr-t--md">{{ 'Release Notes' | translate}}</h3>
            <div class="row release-note-section" *ngIf="releaseNotes && releaseNotes.length; else emptyReleaseNotes">
                <ng-container *ngFor="let note of releaseNotes; let i = index">
                    <div class="col-xs-4 item-block item-block--release-note"
                         *ngIf="i < 3 || showAllNotes == true">
                        <div class="item-block__details d-flex"
                             [routerLink]="[ url]" [queryParams]="{type: 'release-note', lang: language, id: note.id}">
                            <div class="item-block--title mb-1">
                                {{ note['version']}}
                            </div>
                            <div class="item-block--description" [innerHTML]="note['description'] || '' | safeHtml">
                            </div>
                            <button class="item-block--btn btn btn-radius pull-left hidden">
                                {{ 'See all features' | translate }}
                            </button>
                        </div>
                    </div>
                </ng-container>

                <div style="clear: both;"></div>
                <button *ngIf="releaseNotes?.length > 3 && !showAllNotes" class="item-block--btn btn btn-radius pull-right mr-1" (click)="showAllNotes = true">
                    {{ 'Show all Release notes' | translate }}
                </button>
            </div>


            <ng-template #emptyReleaseNotes>
                {{ 'Have no Release Note' | translate}}
            </ng-template>
        </div>

        <div class="card-block card--box__block">
            <h3 class="card--box__block--title mr-t--md">{{ 'Your contact' | translate}}</h3>
            <div class="row" *ngIf="informations">
                <div class="col-xs-11">
                    <div class="info-text" [innerHTML]="informations['support_template_' + language] "></div>
                </div>
                <div class="col-xs-11">
                    <a href="mailto:{{informations['support_email_' + language]}}">{{ informations['support_email_' + language] }}</a>
                </div>
                <div class="col-xs-11">
                    <a href="tel:{{informations['support_phone_' + language]}}">{{ informations['support_phone_' + language] }}</a>
                </div>
            </div>
        </div>
    </div>
</div>
